// extracted by mini-css-extract-plugin
module.exports = {"messages":"Messages_messages__16lM-"};